var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _rect, _g23, _g24, _rect2, _g25, _g26, _rect3, _g27, _rect4, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _rect5, _g35, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 381,
    viewBox: "0 0 616 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_108_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 88H251V336C251 341.523 246.523 346 241 346H56C50.4772 346 46 341.523 46 336V88Z",
    fill: "url(#paint0_linear_108_358)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 237,
    height: 58,
    rx: 15,
    fill: "url(#paint1_linear_108_358)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 116,
    width: 237,
    height: 58,
    rx: 15,
    fill: "url(#paint2_linear_108_358)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 202,
    width: 237,
    height: 58,
    rx: 15,
    fill: "url(#paint3_linear_108_358)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 288,
    width: 237,
    height: 58,
    rx: 15,
    fill: "url(#paint4_linear_108_358)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 51,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint5_linear_108_358)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter6_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 51,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint6_linear_108_358)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter7_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 51,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint7_linear_108_358)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 137,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint8_linear_108_358)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 137,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint9_linear_108_358)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter10_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 137,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint10_linear_108_358)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter11_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 224,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint11_linear_108_358)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 224,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint12_linear_108_358)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 224,
    width: 15,
    height: 15,
    rx: 3,
    fill: "url(#paint13_linear_108_358)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.206 297.105H133.587C131.938 282.129 118.744 270.392 103.077 270.392C97.7166 270.392 92.5627 271.809 88.0274 274.237C82.0489 262.297 69.6797 254 55.0429 254C34.8399 254 18.5538 269.987 18.5538 289.82C18.5538 292.653 18.9661 295.284 19.3784 297.914C8.24611 300.343 0 310.259 0 321.794C0 335.353 11.3384 346.483 25.1507 346.483L29.2737 346.281H129.876L134.206 346.483C148.018 346.483 159.356 335.555 159.356 321.794C159.356 308.033 148.018 297.105 134.206 297.105Z",
    fill: "url(#paint14_linear_108_358)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_bd_108_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.01 216.024H511.374C507.011 176.41 472.11 145.361 430.665 145.361C416.487 145.361 402.853 149.108 390.856 155.532C375.041 123.948 342.322 102 303.603 102C250.161 102 207.08 144.291 207.08 196.752C207.08 204.247 208.17 211.206 209.261 218.165C179.813 224.589 158 250.82 158 281.333C158 317.2 187.993 346.643 224.53 346.643L235.437 346.107H501.558L513.01 346.643C549.547 346.643 579.54 317.735 579.54 281.333C579.54 244.931 549.547 216.024 513.01 216.024Z",
    fill: "url(#paint15_linear_108_358)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.819,
    y: 145.929,
    width: 46.8899,
    height: 46.8899,
    rx: 10,
    fill: "url(#paint16_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.567,
    y: 216.263,
    width: 29.561,
    height: 29.561,
    rx: 5,
    fill: "url(#paint17_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter17_bd_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.147,
    y: 249.899,
    width: 29.561,
    height: 29.561,
    rx: 5,
    fill: "url(#paint18_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.561,
    y: 268.247,
    width: 33.6384,
    height: 33.6384,
    rx: 7,
    fill: "url(#paint19_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter19_bd_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.385,
    y: 186.702,
    width: 36.6964,
    height: 36.6964,
    rx: 7,
    fill: "url(#paint20_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_bd_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.683,
    y: 268.247,
    width: 36.6964,
    height: 36.6964,
    rx: 7,
    fill: "url(#paint21_linear_108_358)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter21_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.765,
    y: 212.186,
    width: 36.6964,
    height: 36.6964,
    rx: 7,
    fill: "url(#paint22_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 487.465,
    y: 107,
    width: 36.6964,
    height: 36.6964,
    rx: 7,
    fill: "url(#paint23_linear_108_358)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter22_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.623,
    y: 239.708,
    width: 36.6964,
    height: 36.6964,
    rx: 7,
    fill: "url(#paint24_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter23_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.694,
    y: 245.824,
    width: 36.6964,
    height: 36.6964,
    rx: 7,
    fill: "url(#paint25_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 536.394,
    y: 140.638,
    width: 36.6964,
    height: 36.6964,
    rx: 7,
    fill: "url(#paint26_linear_108_358)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter24_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.96,
    y: 286.596,
    width: 48.9286,
    height: 48.9286,
    rx: 10,
    fill: "url(#paint27_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.3,
    y: 256.015,
    width: 48.9286,
    height: 48.9286,
    rx: 10,
    fill: "url(#paint28_linear_108_358)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 463,
    y: 150.829,
    width: 48.9286,
    height: 48.9286,
    rx: 10,
    fill: "url(#paint29_linear_108_358)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_bd_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.379,
    y: 181.606,
    width: 64.2187,
    height: 64.2187,
    rx: 10,
    fill: "url(#paint30_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 335.561,
    y: 90.8899,
    width: 64.2187,
    height: 64.2187,
    rx: 10,
    fill: "url(#paint31_linear_108_358)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter27_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.623,
    y: 169.373,
    width: 64.2187,
    height: 64.2187,
    rx: 10,
    fill: "url(#paint32_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.225,
    y: 120.445,
    width: 29.561,
    height: 29.561,
    rx: 5,
    fill: "url(#paint33_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_bd_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.237,
    y: 217.283,
    width: 29.561,
    height: 29.561,
    rx: 5,
    fill: "url(#paint34_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter30_bd_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.939,
    y: 295.77,
    width: 29.561,
    height: 29.561,
    rx: 5,
    fill: "url(#paint35_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter31_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 288,
    width: 29.561,
    height: 29.561,
    rx: 5,
    fill: "url(#paint36_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter32_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.676,
    y: 273.344,
    width: 33.6384,
    height: 33.6384,
    rx: 5,
    fill: "url(#paint37_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter33_d_108_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.921,
    y: 134.716,
    width: 35.6771,
    height: 35.6771,
    rx: 7,
    fill: "url(#paint38_linear_108_358)",
    fillOpacity: 0.95,
    shapeRendering: "crispEdges"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 47,
    width: 35.6771,
    height: 35.6771,
    rx: 7,
    fill: "url(#paint39_linear_108_358)"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_108_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.43 295.253C375.37 296.686 372.637 296.686 370.577 295.253L324.574 263.255C322.961 262.134 322 260.294 322 258.33V181.236C322 178.718 323.567 176.487 325.992 175.809C333.217 173.789 349.981 170 374.07 170C398.145 170 414.829 173.785 422.021 175.806C424.439 176.485 426 178.712 426 181.225V258.33C426 260.294 425.039 262.134 423.426 263.255L377.43 295.253Z",
    fill: "url(#paint40_linear_108_358)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403 229.18C403 224.984 401.278 220.96 398.212 217.994C395.147 215.027 390.989 213.36 386.653 213.36C385.739 213.376 384.828 213.464 383.929 213.624C382.665 210.107 380.161 207.135 376.856 205.229C373.551 203.324 369.658 202.607 365.861 203.206C362.065 203.804 358.608 205.679 356.098 208.501C353.589 211.323 352.189 214.911 352.143 218.633C352.155 220.547 352.53 222.441 353.251 224.223C350.682 224.846 348.434 226.353 346.93 228.462C345.425 230.572 344.765 233.14 345.075 235.686C345.384 238.232 346.641 240.582 348.61 242.296C350.58 244.01 353.127 244.971 355.776 245H388.47V244.824C392.452 244.393 396.132 242.562 398.811 239.678C401.489 236.794 402.98 233.058 403 229.18Z",
    fill: "url(#paint41_linear_108_358)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M476.117 309.761H476.759C478.472 294.21 492.172 282.022 508.442 282.022C514.007 282.022 519.359 283.493 524.069 286.014C530.277 273.616 543.121 265 558.32 265C579.299 265 596.211 281.601 596.211 302.195C596.211 305.137 595.783 307.869 595.355 310.601C606.915 313.123 615.478 323.42 615.478 335.398C615.478 349.478 603.704 361.036 589.361 361.036L585.079 360.826H480.612L476.117 361.036C461.774 361.036 450 349.688 450 335.398C450 321.108 461.774 309.761 476.117 309.761Z",
    fill: "url(#paint42_linear_108_358)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_108_358",
    x: 36,
    y: 78,
    width: 225,
    height: 278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_108_358",
    x: 10,
    y: 20,
    width: 277,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_108_358",
    x: 10,
    y: 106,
    width: 277,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_108_358",
    x: 10,
    y: 192,
    width: 277,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_108_358",
    x: 10,
    y: 278,
    width: 277,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_108_358",
    x: 42,
    y: 48,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_108_358",
    x: 66,
    y: 48,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_108_358",
    x: 90,
    y: 48,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_108_358",
    x: 42,
    y: 134,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_108_358",
    x: 66,
    y: 134,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_108_358",
    x: 90,
    y: 134,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_108_358",
    x: 42,
    y: 221,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_108_358",
    x: 66,
    y: 221,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_108_358",
    x: 90,
    y: 221,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_bd_108_358",
    x: 128,
    y: 76,
    width: 481.54,
    height: 304.643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_108_358",
    result: "effect2_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_108_358",
    x: 244.819,
    y: 135.929,
    width: 66.8899,
    height: 66.8899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_108_358",
    x: 231.567,
    y: 206.263,
    width: 49.561,
    height: 49.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_bd_108_358",
    x: 262.147,
    y: 239.899,
    width: 49.561,
    height: 49.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_108_358",
    result: "effect2_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_108_358",
    x: 178.561,
    y: 258.247,
    width: 53.6384,
    height: 53.6384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_bd_108_358",
    x: 327.385,
    y: 176.702,
    width: 56.6964,
    height: 56.6964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_108_358",
    result: "effect2_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_bd_108_358",
    x: 237.683,
    y: 258.247,
    width: 56.6964,
    height: 56.6964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_108_358",
    result: "effect2_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_108_358",
    x: 452.765,
    y: 202.186,
    width: 56.6964,
    height: 56.6964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_108_358",
    x: 392.623,
    y: 229.708,
    width: 56.6964,
    height: 56.6964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_108_358",
    x: 501.694,
    y: 235.824,
    width: 56.6964,
    height: 56.6964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_108_358",
    x: 304.96,
    y: 276.596,
    width: 68.9286,
    height: 68.9286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_108_358",
    x: 428.3,
    y: 246.015,
    width: 68.9286,
    height: 68.9286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_bd_108_358",
    x: 274.379,
    y: 171.606,
    width: 84.2188,
    height: 84.2187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_108_358",
    result: "effect2_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_108_358",
    x: 392.623,
    y: 159.373,
    width: 84.2188,
    height: 84.2187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_108_358",
    x: 266.225,
    y: 110.445,
    width: 49.561,
    height: 49.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_bd_108_358",
    x: 372.237,
    y: 207.283,
    width: 49.561,
    height: 49.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_108_358",
    result: "effect2_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_bd_108_358",
    x: 461.939,
    y: 285.77,
    width: 49.561,
    height: 49.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_108_358"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_108_358",
    result: "effect2_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_108_358",
    x: 413,
    y: 278,
    width: 49.561,
    height: 49.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_108_358",
    x: 342.676,
    y: 263.344,
    width: 53.6384,
    height: 53.6384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_108_358",
    x: 302.921,
    y: 124.716,
    width: 55.6771,
    height: 55.6771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_108_358",
    x: 308.059,
    y: 165.353,
    width: 131.882,
    height: 154.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.29412
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.97059
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0 0.282353 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_358",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_358",
    x1: 65.3762,
    y1: 407.828,
    x2: 206.76,
    y2: 271.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA0EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21214C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_358",
    x1: 30,
    y1: 45,
    x2: 77.6724,
    y2: 84.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9043C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_108_358",
    x1: 30,
    y1: 131,
    x2: 77.6724,
    y2: 170.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9043C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_108_358",
    x1: 30,
    y1: 217,
    x2: 77.6724,
    y2: 256.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9043C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_108_358",
    x1: 30,
    y1: 303,
    x2: 77.6724,
    y2: 342.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9043C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_108_358",
    x1: 46,
    y1: 51,
    x2: 63.6471,
    y2: 55.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_108_358",
    x1: 70,
    y1: 51,
    x2: 87.6471,
    y2: 55.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_108_358",
    x1: 94,
    y1: 51,
    x2: 111.647,
    y2: 55.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_108_358",
    x1: 61,
    y1: 152,
    x2: 43.8383,
    y2: 140.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_108_358",
    x1: 85,
    y1: 152,
    x2: 67.8383,
    y2: 140.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_108_358",
    x1: 109,
    y1: 152,
    x2: 91.8383,
    y2: 140.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_108_358",
    x1: 46,
    y1: 224,
    x2: 63.6471,
    y2: 228.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_108_358",
    x1: 70,
    y1: 224,
    x2: 87.6471,
    y2: 228.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_108_358",
    x1: 94,
    y1: 224,
    x2: 111.647,
    y2: 228.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_108_358",
    x1: 32.1343,
    y1: 252.32,
    x2: 121.436,
    y2: 387.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_108_358",
    x1: 158,
    y1: 102,
    x2: 378.854,
    y2: 467.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_108_358",
    x1: 264.274,
    y1: 145.077,
    x2: 313.109,
    y2: 188.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_108_358",
    x1: 247.528,
    y1: 215.726,
    x2: 278.315,
    y2: 242.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_108_358",
    x1: 278.108,
    y1: 249.362,
    x2: 308.895,
    y2: 276.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_108_358",
    x1: 195.344,
    y1: 267.636,
    x2: 230.378,
    y2: 298.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_108_358",
    x1: 344.785,
    y1: 186.036,
    x2: 383.004,
    y2: 219.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_108_358",
    x1: 284.379,
    y1: 304.944,
    x2: 242.395,
    y2: 275.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_108_358",
    x1: 470.165,
    y1: 211.52,
    x2: 508.383,
    y2: 245.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_108_358",
    x1: 487.465,
    y1: 107,
    x2: 524.872,
    y2: 142.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_108_358",
    x1: 410.023,
    y1: 239.042,
    x2: 448.242,
    y2: 272.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_108_358",
    x1: 519.094,
    y1: 245.158,
    x2: 557.312,
    y2: 278.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_108_358",
    x1: 536.394,
    y1: 140.638,
    x2: 579.566,
    y2: 151.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_108_358",
    x1: 324.826,
    y1: 285.707,
    x2: 375.784,
    y2: 330.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_108_358",
    x1: 438.3,
    y1: 256.015,
    x2: 495.863,
    y2: 270.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_108_358",
    x1: 511.929,
    y1: 199.758,
    x2: 455.949,
    y2: 161.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_108_358",
    x1: 297.329,
    y1: 180.439,
    x2: 364.211,
    y2: 239.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_108_358",
    x1: 335.561,
    y1: 90.8899,
    x2: 411.112,
    y2: 109.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B59A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_108_358",
    x1: 415.573,
    y1: 168.207,
    x2: 482.455,
    y2: 227.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_108_358",
    x1: 282.186,
    y1: 119.908,
    x2: 312.973,
    y2: 146.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_108_358",
    x1: 388.198,
    y1: 216.746,
    x2: 418.985,
    y2: 243.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_108_358",
    x1: 477.9,
    y1: 295.233,
    x2: 508.687,
    y2: 322.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_108_358",
    x1: 428.961,
    y1: 287.463,
    x2: 459.748,
    y2: 314.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_108_358",
    x1: 359.459,
    y1: 272.733,
    x2: 394.492,
    y2: 303.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_108_358",
    x1: 320.116,
    y1: 134.068,
    x2: 357.272,
    y2: 166.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_108_358",
    x1: 313,
    y1: 47,
    x2: 349.368,
    y2: 81.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_108_358",
    x1: 426,
    y1: 297.636,
    x2: 292.482,
    y2: 222.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_108_358",
    x1: 353.373,
    y1: 203,
    x2: 418.316,
    y2: 228.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBAF14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_108_358",
    x1: 582.109,
    y1: 263.256,
    x2: 489.377,
    y2: 403.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode1);
export default __webpack_public_path__ + "static/media/code1.051a3dd1cf18845074cf1057f49e9b6a.svg";
export { ForwardRef as ReactComponent };